import { useSyncExternalStore } from 'react';

const QUERY = '(hover: none) and (pointer: coarse)';
function subscribe(notify: () => void) {
  const media = window.matchMedia(QUERY);
  media.addEventListener('change', notify);
  return () => media.removeEventListener('change', notify);
}
function snapshot() { return window.matchMedia(QUERY).matches; }
export function useCoarsePointer() {
  return useSyncExternalStore(subscribe, snapshot, () => false);
}
